import { useEffect, useRef, useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './styles.js';

//swiper slide
import { Swiper, SwiperSlide } from "swiper/react";
import { Container } from './styles.js';
import { Link } from 'react-router-dom';

export default function Cast( { cast, movie_type } ) {

    const image_path = 'https://image.tmdb.org/t/p/w138_and_h175_face';

    const [ castLengthVisible, setCastLengthVisible ] = useState(15);
    const [ loadingCast, setLoadingCast ] = useState(true);
 
    const swiperRef = useRef(null);
    const firstPersonRef = useRef(null);

    useEffect(()=> {
        setCastLengthVisible(15);
        
        if (swiperRef && swiperRef.current) {
            swiperRef.current.swiper.slideTo(0);
        }
    }, [ cast ]);
    
    const loadMore = () => {
        const remainingElenco = cast.length - castLengthVisible;
        const nextBatch = Math.min(remainingElenco, 10);
        setCastLengthVisible(prevCastLengthVisible => prevCastLengthVisible + nextBatch);
    };

    return (
        <>
            {(cast?.length >= 1) &&
                <Container>
                    <h2 className="title">Elenco</h2>
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={10}
                        freeMode={false}
                        className='swiper'
                        pagination={{
                            clickable: true,
                        }}
                        ref={swiperRef}
                    >
                        {cast.slice(0, castLengthVisible).map((person, key) => {
                            return(
                                <SwiperSlide key={key}  ref={key == 0 ? firstPersonRef : null}>
                                    <Link to={`?pessoa=${person?.person_id}`} className={`person`}>
                                        <img loading="lazy" src={person?.profile_path ? (`${image_path}${person?.profile_path}`) : 'https://dflix.netlify.app/imagens/img-avatar.png'} alt={person?.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src='https://dflix.netlify.app/imagens/img-avatar.png';}}/>
                                        <section className='section-person-details'>
                                            {person?.name && 
                                                <span className='name'>{person?.name}</span>
                                            }
                                            {(movie_type == 'movie' && person?.character) &&
                                                <span className='character'>{person?.character}</span>
                                            }
                                            {(movie_type == 'tv' && person?.roles && person?.roles[0]) &&
                                                <>
                                                    <span className='character'>{person?.roles[0].character}</span>
                                                    <span className='character'>{person?.roles[0].episode_count} Episódio{person?.roles[0].episode_count > 1 ? 's' : ''}</span>
                                                </>
                                            }
                                        </section>
                                    </Link>
                                </SwiperSlide>
                            )
                        })}
                        <SwiperSlide>
                            {cast.length > castLengthVisible && (
                                <div className='container-button-see-more'>
                                    <button onClick={loadMore}><i className='fas fa-plus'></i></button>
                                </div>
                            )}
                        </SwiperSlide>
                        
                    </Swiper>
                </Container>
            }
        </>
    )
}